<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
    &copy; {{year}}, 8bit Solutions LLC
    <br> {{'versionNumber' | i18n : version}}
</div>
